export default class CacheEntry {

	constructor(item, ttl) {
		this.expire = (new Date()).getTime() + (ttl * 1000);
		this.item = item;
	}
}